import styled, { css } from 'styled-components';
import Box from '@tds/core-box';

const Backdrop = styled(Box)`
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 999;
`;

const Content = styled(Box)`
  overflow: scroll;
  height: 100%;
  width: 60%;
  position: fixed;
  top: 10%;
  left: 20%;
  background-color: white;
  @media screen and (max-width: 992px) {
    width: 100%;
    top: 0;
    left: 0;
  }

  ${props =>
    props.customStyles &&
    css`
      ${props.customStyles}
    `}
`;

const Button = styled.button`
  border: none;
  cursor: pointer;
  margin-right: 7px;
  background: none;
  font-size: ${props => props.popupHeader && '16px'};
  font-weight: ${props => props.popupHeader && '400'};
  color: ${props => props.popupHeader && '#fff'};
`;

const Heading = styled.h1`
  font-size: 24px;
  font-weight: 500;
  color: #fff;
`;

const FixedContent = styled(Box)`
  display: flex;
  justify-content: space-between;
  width: inherit;
  flex-direction: row;
  padding: 10px 20px;
  position: fixed;
  background: #8c68a6;
  z-index: 100;
`;

const ChildrenContent = styled(Box)`
  padding: 0 20px 32px 20px;
  position: relative;
  top: 70px;
`;

export { Backdrop, Content, Button, Heading, FixedContent, ChildrenContent };
